import {
  OeIcon1,
  OeIcon2,
  OeIcon3,
  OeIcon4,
  OeIcon8,
} from 'components/Common/Icon'
import { SubText, TitleH2 } from 'components/Common/Typography'
import LinkButton from 'components/LinkButton'
import Image from 'next/image'
import Link from 'next/link'
import { Col, Container, Row } from 'react-bootstrap'

function Services() {
  return (
    <section className="our_experties d-flex align-items-center">
      <Container>
        <Row className="align-items-stretch">
          <Col xs={12} xl={8} className="mb-5">
            <div data-aos="fade-up">
              <TitleH2 className="text_black mb-3" text="Our Expertise" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
              <SubText
                className="mb-2 pt-2"
                text="WebClues Infotech is an agile and proactive development services provider creating new digital experiences for your end users with intelligent solutions. We use intelligent practices, advanced technologies, and adaptive systems for your development solutions.
              "
              />
            </div>
          </Col>
        </Row>
        <Row className="align-items-stretch">
          <Col xs={12} md={6} lg={4} className="mb-4">
            <Link
              href="/blockchain-development-services"
              className="text-decoration-none cursorArrowArea"
            >
              <div
                className="our_experties_block d-flex flex-column hvr-icon-hang h-100"
                data-aos="zoom-in"
              >
                <div className="oe_icon mb-3">
                  <OeIcon8 />
                </div>
                <h3 className="title_sm text_black fw-700 mb-1">
                  Blockchain Development
                </h3>
                <p className="mb-0 pt-2 pt-lg-4 text_para">
                  Building blockchain-enabled solutions from scratch with
                  precision planning and strategies to help your business
                  leverage advanced functioning.
                </p>
              </div>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={4} className="mb-4">
            <Link
              href="/ai-ml-development-services"
              className="text-decoration-none cursorArrowArea"
            >
              <div
                className="our_experties_block d-flex flex-column hvr-icon-hang h-100"
                data-aos="zoom-in"
              >
                <div className="oe_icon mb-3">
                  <Image
                    src="/assets/images/AiMlNewIcon.svg"
                    alt="AiMl"
                    width={70}
                    height={70}
                    className="hvr-icon"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
                <h3 className="title_sm text_black fw-700 mb-1">
                  AI/ML <br /> Development
                </h3>
                <p className="mb-0 pt-2 pt-md-4 text_para">
                  We leverage machine learning technologies and AI algorithms to
                  build innovative and intelligent applications to improve
                  business processes and communication.
                </p>
              </div>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={4} className="mb-4">
            <Link
              href="/hire-dedicated-developers"
              className="text-decoration-none cursorArrowArea"
            >
              <div
                className="our_experties_block d-flex flex-column hvr-icon-hang h-100"
                data-aos="zoom-in"
              >
                <div className="oe_icon mb-3">
                  <OeIcon3 />
                </div>
                <h3 className="title_sm text_black fw-700 mb-1">
                  Team <br /> Extension
                </h3>
                <p className="mb-0 pt-2 pt-md-4 text_para">
                  Outsource software development services with our team
                  extension development model to create bespoke solutions and
                  software.
                </p>
              </div>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={4} className="mb-4">
            <Link
              href="/product-engineering-services"
              className="text-decoration-none cursorArrowArea"
            >
              <div
                className="our_experties_block d-flex flex-column hvr-icon-hang h-100"
                data-aos="zoom-in"
              >
                <div className="oe_icon mb-3">
                  <OeIcon4 />
                </div>
                <h3 className="title_sm text_black fw-700 mb-1">
                  Product <br className="d-none d-xl-block" /> Engineering
                </h3>
                <p className="mb-0 pt-2 pt-md-4 text_para">
                  We will build your roadmap to excellence and sustainability
                  with the combination of hardware, embedded, and software
                  solutions.
                </p>
              </div>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={4} className="mb-4">
            <Link
              href="/web-development-services"
              className="text-decoration-none cursorArrowArea"
            >
              <div
                className="our_experties_block d-flex flex-column hvr-icon-hang h-100"
                data-aos="zoom-in"
              >
                <div className="oe_icon mb-3">
                  <OeIcon1 />
                </div>
                <h3 className="title_sm text_black fw-700 mb-1">
                  Web <br className="d-none d-xl-block" />
                  Development
                </h3>
                <p className="mb-0 pt-2 pt-lg-4 text_para">
                  We ideate, create, manage, and scale web solutions for your
                  business with the best technologies.
                </p>
              </div>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={4} className="mb-4">
            <Link
              href="/mobile-app-development-services"
              className="text-decoration-none cursorArrowArea"
            >
              <div
                className="our_experties_block d-flex flex-column hvr-icon-hang h-100"
                data-aos="zoom-in"
              >
                <div className="oe_icon mb-3">
                  <OeIcon2 />
                </div>
                <h3 className="title_sm text_black fw-700 mb-1">
                  Mobility <br className="d-none d-xl-block" /> Services
                </h3>
                <p className="mb-0 pt-2 pt-lg-4 text_para">
                  Our developers create real-time customer experiences backed
                  with data for precision mobility in mobile and web apps.
                </p>
              </div>
            </Link>
          </Col>
          {/* <Col xs={12} md={6} lg={4} className="mb-4">
            <Link href="/data-analytics-services">
              <a className="text-decoration-none cursorArrowArea">
                <div
                  className="our_experties_block d-flex flex-column hvr-icon-hang"
                  data-aos="zoom-in"
                  data-aos-delay="500"
                >
                  <div className="oe_icon">
                    <OeIcon7 />
                  </div>
                  <h3 className="title_sm_black mb-1 mt-5 mt-lg-auto">
                    Data Analytics
                  </h3>
                  <p className="mb-0 pt-2 pt-lg-4 text_para">
                    Unlock new insights and possibilities specific to your
                    business and create bespoke user experiences with accurate
                    data.
                  </p>
                </div>
              </a>
            </Link>
          </Col> */}
        </Row>

        <Row>
          <Col className="mt-5 pt-0 pt-lg-1 text-center">
            <LinkButton
              path="/it-solutions"
              className="text-decoration-none mx-auto"
              dataAos="fade-up"
              dataAosDelay="600"
            >
              <span>See More Services</span>
            </LinkButton>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Services
